import { Injectable } from '@angular/core'
import { ApiClient, ApiClientFactory, serializeHttpParams } from '@ftr/api-shared'
import { UserGroup } from '@ftr/contracts/api/user-group'
import { UserGetGroupsParams } from '@ftr/contracts/read'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'

@Injectable({
  providedIn: 'root',
})
export class UserPermissionService {
  private readonly userApiClient: ApiClient

  constructor(private apiClientFactory: ApiClientFactory) {
    this.userApiClient = this.apiClientFactory.build('/user')
  }

  fetchCurrentUserGroups(): ApiResult<UserGroup[]> {
    return this.userApiClient.get({ path: '/groups' })
  }

  fetchCurrentUserGroupsForCourtSystem(courtSystemId: Uuid): ApiResult<UserGroup[]> {
    const queryParameters: UserGetGroupsParams = {
      courtSystemId,
    }
    return this.userApiClient.get({ path: '/groups', params: serializeHttpParams(queryParameters) })
  }
}
